import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type UpdateCategoryDimensionPayload = {
	categoryDimensionUid: string;
	sequence: number;
	weight: number;
	isTextbox: boolean;
	isBackofficeRequired: boolean;
	isPublicRequired: boolean;
	localizations: {
		"en-us": string;
		"de-ch": string;
		"de-de": string;
		"fr-fr": string;
		"it-it": string;
	};
};

const updateCategoryDimension = async (payload: UpdateCategoryDimensionPayload): Promise<any> => { 
	const response = await apiDal.post("/categorydimension/update", payload);
	return response.data;
};

export const useUpdateCategoryDimension = () => {
	return useMutation({
		mutationFn: updateCategoryDimension,
	});
};
